// Shared page size for the "full" combinations request (watcher page 0 and
// load-more pages). Server caps pageSize at 100.
export const BACKGROUND_PAGE_SIZE = 50;

export type ValidSystemsRequestEntry = {
  body: Record<string, unknown>;
  hash: string;
};

// Module-level registry of the last "full" valid-systems request body the
// watcher sent per configuration. The load-more thunk re-sends the exact
// same body with an incremented page so the server's scored-combinations
// cache key matches and appended pages never overlap or skip. Kept outside
// Redux because the body is a large transient request payload, not app state.
const registry = new Map<string, ValidSystemsRequestEntry>();

export const registerValidSystemsRequest = (
  configId: string,
  body: Record<string, unknown>,
  hash: string
): void => {
  registry.set(configId, { body, hash });
};

export const getValidSystemsRequest = (
  configId: string
): ValidSystemsRequestEntry | undefined => registry.get(configId);

export const unregisterValidSystemsRequest = (configId: string): void => {
  registry.delete(configId);
};

export const pruneValidSystemsRequests = (keepConfigIds: Set<string>): void => {
  Array.from(registry.keys()).forEach((configId) => {
    if (!keepConfigIds.has(configId)) {
      registry.delete(configId);
    }
  });
};
